import { Pipe, PipeTransform } from '@angular/core';
import { User as IAMUser } from '@vendasta/iamv2';
import { User } from '../../core/user';

@Pipe({
  standalone: true,
  name: 'userDisplayName',
})
export class UserDisplayNamePipe implements PipeTransform {
  // formats a user to 'First Last (Email)' or 'Email'
  transform(user: User | IAMUser, hideEmailIfNameExists?: boolean): string {
    if (!user) {
      return '';
    }

    const names: string[] = [];
    if (user?.firstName) {
      names.push(user.firstName.trim());
    }
    if (user?.lastName) {
      names.push(user.lastName.trim());
    }
    if (names.length > 0 && !hideEmailIfNameExists && !!user.email) {
      names.push(`(${user.email})`);
    }

    const name = names.join(' ');
    const email = user.email ? user.email : '';
    return name === '' ? email : name;
  }
}
